export default __webpack_public_path__ + "static/media/news-15.74fa1ca0.png";